<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>User Device Information</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.datas"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.item.id }}</td>
        <td class="text-xs-center">{{ props.item.user_id }}</td>
        <td class="text-xs-center">{{ props.item.device_key }}</td>
        <td class="text-xs-center">{{ props.item.device_name }}</td>
        <td class="text-xs-center">{{ props.item.model_no }}</td>
        <td class="text-xs-center">{{ props.item.os_version }}</td>
        <td class="text-xs-center">{{ props.item.latitude }}</td>
        <td class="text-xs-center">{{ props.item.longitude }}</td>
        <td class="justify-center layout px-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="deleteItem(props.item.id)"
              >
                delete
              </v-icon>
            </template>
            <span>delete</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      search: "",
      apiUrl: "user-device-info",
      headers: [
        { text: "SN#", align: "center", value: "id" },
        { text: "User ID", align: "center", value: "user_id" },
        { text: "Device ID", align: "center", value: "device_key" },
        {
          text: "Device Name",
          align: "center",
          sortable: false,
          value: "device_name",
        },
        {
          text: "Model No",
          align: "center",
          sortable: false,
          value: "model_no",
        },
        {
          text: "OS",
          align: "center",
          sortable: false,
          value: "os_version",
        },
        {
          text: "Latitude",
          align: "center",
          sortable: false,
          value: "latitude",
        },
        {
          text: "Longitude",
          align: "center",
          sortable: false,
          value: "longitude",
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "delete",
        },
      ],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.$store.dispatch("setIndexData", [this.apiUrl]);
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },
      deleteItem(itemId) {
        var popUpMsg = confirm("Are you sure you want to delete this item?");
        if (popUpMsg) {
          this.$store.dispatch("delete", [this.apiUrl, itemId]);
          this.initialize();
        }
      },
    },
  };
</script>
